/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

export const logoRatio = 266 / 70;

const LogoH1 = styled.h1`
  margin: 0;
`;

export const Logo = ({ width, ...next }) => {
  const height = width / logoRatio;

  return (
    <LogoH1 {...next}>
      <svg
        /* eslint-disable-next-line react/no-unknown-property */
        data-xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 229 44"
      >
        <g fill="none">
          <path
            fill="#99E133"
            d="M0.2,11.9 L2.5,23 C2.6,23.6 3.1,24.1 3.7,24.2 L14.8,26.5 C15.5,26.6 16.3,26.4 16.8,25.9 L26,16.7 C26.9,15.8 26.9,14.5 26,13.6 L13.1,0.6 C12.3,-0.2 10.9,-0.2 10,0.6 L0.8,9.8 C0.3,10.4 -5.55111512e-16,11.2 0.2,11.9 Z"
            opacity=".75"
            transform="translate(17 1)"
          />
          <path
            fill="#00A652"
            d="M27.4,14.7 L25.1,3.6 C25,3 24.5,2.5 23.9,2.4 L12.8,0.1 C12.1,-1.73472348e-15 11.3,0.2 10.8,0.7 L1.6,10 C0.7,10.9 0.7,12.2 1.6,13.1 L14.5,26 C15.3,26.8 16.7,26.8 17.6,26 L26.8,16.8 C27.3,16.2 27.5,15.4 27.4,14.7 Z"
            transform="translate(0 17)"
          />
          <path
            fill="#99E133"
            d="M11.9,27.4 L23,25.1 C23.6,25 24.1,24.5 24.2,23.9 L26.5,12.8 C26.6,12.1 26.4,11.3 25.9,10.8 L16.7,1.6 C15.8,0.7 14.5,0.7 13.6,1.6 L0.6,14.5 C-0.2,15.3 -0.2,16.7 0.6,17.6 L9.8,26.8 C10.4,27.3 11.2,27.5 11.9,27.4 Z"
            opacity=".75"
            transform="translate(1)"
          />
          <path
            fill="#99E133"
            d="M14.7,0.2 L3.6,2.5 C3,2.6 2.5,3.1 2.4,3.7 L0.1,14.8 C-1.74860126e-15,15.5 0.2,16.3 0.7,16.8 L9.9,26 C10.8,26.9 12.1,26.9 13,26 L25.9,13.1 C26.7,12.3 26.7,10.9 25.9,10 L16.7,0.8 C16.2,0.3 15.4,-5.55111512e-16 14.7,0.2 Z"
            opacity=".75"
            transform="translate(17 17)"
          />
          <g transform="translate(55 13)">
            <path
              fill="#99E133"
              d="M0.3,2.2 C0.3,1.4 1,0.8 1.9,0.8 C2.8,0.8 3.5,1.3 3.5,2.2 L3.5,2.3 C3.5,3.1 2.8,3.7 1.9,3.7 C1,3.7 0.3,3.1 0.3,2.3 L0.3,2.2 Z"
            />
            <path
              fill="#FFF"
              d="M.5 6.7C.5 5.9 1.1 5.3 1.9 5.3 2.7 5.3 3.3 5.9 3.3 6.7L3.3 16.3C3.3 17.1 2.7 17.7 1.9 17.7 1.1 17.7.5 17.1.5 16.3L.5 6.7zM6.4 6.7C6.4 5.9 7 5.3 7.8 5.3 8.6 5.3 9.2 5.9 9.2 6.7L9.2 7.3C10 6.2 11.1 5.2 13 5.2 15.7 5.2 17.3 7 17.3 9.8L17.3 16.3C17.3 17.1 16.7 17.7 15.9 17.7 15.1 17.7 14.5 17.1 14.5 16.3L14.5 10.7C14.5 8.8 13.6 7.7 11.9 7.7 10.3 7.7 9.2 8.8 9.2 10.7L9.2 16.3C9.2 17.1 8.6 17.7 7.8 17.7 7 17.7 6.4 17.1 6.4 16.3L6.4 6.7zM24.7 17.8L24.6 17.8C23.8 17.8 23.3 17.3 23 16.6L19 7.3C18.9 7.1 18.8 6.9 18.8 6.6 18.8 5.9 19.4 5.3 20.2 5.3 21 5.3 21.3 5.7 21.6 6.3L24.7 14.3 27.9 6.2C28.1 5.7 28.5 5.2 29.2 5.2 30 5.2 30.6 5.8 30.6 6.5 30.6 6.8 30.5 7 30.4 7.2L26.4 16.5C26 17.3 25.5 17.8 24.7 17.8z"
            />
            <path
              fill="#99E133"
              d="M32.2,2.2 C32.2,1.4 32.9,0.8 33.8,0.8 C34.7,0.8 35.4,1.3 35.4,2.2 L35.4,2.3 C35.4,3.1 34.7,3.7 33.8,3.7 C32.9,3.7 32.2,3.1 32.2,2.3 L32.2,2.2 Z"
            />
            <path
              fill="#FFF"
              d="M32.4 6.7C32.4 5.9 33 5.3 33.8 5.3 34.6 5.3 35.2 5.9 35.2 6.7L35.2 16.3C35.2 17.1 34.6 17.7 33.8 17.7 33 17.7 32.4 17.1 32.4 16.3L32.4 6.7zM38.7 14.2L38.7 7.8 38.2 7.8C37.5 7.8 37 7.3 37 6.6 37 5.9 37.5 5.4 38.2 5.4L38.7 5.4 38.7 3.3C38.7 2.5 39.3 1.9 40.1 1.9 40.9 1.9 41.5 2.5 41.5 3.3L41.5 5.4 43.7 5.4C44.4 5.4 44.9 5.9 44.9 6.6 44.9 7.3 44.3 7.8 43.7 7.8L41.5 7.8 41.5 13.8C41.5 14.9 42.1 15.3 43 15.3 43.3 15.3 43.6 15.2 43.7 15.2 44.3 15.2 44.9 15.7 44.9 16.3 44.9 16.8 44.6 17.2 44.2 17.4 43.6 17.6 43 17.7 42.3 17.7 40.2 17.8 38.7 16.9 38.7 14.2zM46.2 14.1C46.2 11.4 48.2 10.1 51.2 10.1 52.6 10.1 53.5 10.3 54.5 10.6L54.5 10.3C54.5 8.6 53.4 7.7 51.5 7.7 50.4 7.7 49.6 7.9 48.8 8.2 48.6 8.2 48.5 8.3 48.4 8.3 47.8 8.3 47.2 7.8 47.2 7.2 47.2 6.7 47.5 6.3 48 6.1 49.1 5.7 50.3 5.4 51.9 5.4 53.7 5.4 55.1 5.9 55.9 6.8 56.8 7.7 57.2 9 57.2 10.5L57.2 16.5C57.2 17.3 56.6 17.8 55.8 17.8 55 17.8 54.4 17.2 54.4 16.6L54.4 16.1C53.6 17.1 52.3 17.9 50.4 17.9 48.2 17.9 46.2 16.5 46.2 14.1zM54.5 13.2L54.5 12.4C53.8 12.1 52.8 11.9 51.7 11.9 49.9 11.9 48.8 12.7 48.8 13.9 48.8 15.1 49.8 15.7 51.2 15.7 53.1 15.8 54.5 14.8 54.5 13.2zM60.4 14.2L60.4 7.8 59.9 7.8C59.2 7.8 58.7 7.3 58.7 6.6 58.7 5.9 59.2 5.4 59.9 5.4L60.4 5.4 60.4 3.3C60.4 2.5 61 1.9 61.8 1.9 62.6 1.9 63.2 2.5 63.2 3.3L63.2 5.4 65.4 5.4C66.1 5.4 66.6 5.9 66.6 6.6 66.6 7.3 66 7.8 65.4 7.8L63.2 7.8 63.2 13.8C63.2 14.9 63.8 15.3 64.7 15.3 65 15.3 65.3 15.2 65.4 15.2 66 15.2 66.6 15.7 66.6 16.3 66.6 16.8 66.3 17.2 65.9 17.4 65.3 17.6 64.7 17.7 64 17.7 61.8 17.8 60.4 16.9 60.4 14.2z"
            />
            <path
              fill="#99E133"
              d="M68.3,2.2 C68.3,1.4 69,0.8 69.9,0.8 C70.8,0.8 71.5,1.3 71.5,2.2 L71.5,2.3 C71.5,3.1 70.8,3.7 69.9,3.7 C69,3.7 68.3,3.1 68.3,2.3 L68.3,2.2 Z"
            />
            <path
              fill="#FFF"
              d="M68.5 6.7C68.5 5.9 69.1 5.3 69.9 5.3 70.7 5.3 71.3 5.9 71.3 6.7L71.3 16.3C71.3 17.1 70.7 17.7 69.9 17.7 69.1 17.7 68.5 17.1 68.5 16.3L68.5 6.7zM73.7 11.6C73.7 8.1 76.5 5.2 80.2 5.2 83.9 5.2 86.7 8 86.7 11.5 86.7 14.9 83.9 17.8 80.2 17.8 76.4 17.9 73.7 15 73.7 11.6zM83.8 11.6C83.8 9.4 82.3 7.6 80.1 7.6 77.9 7.6 76.4 9.3 76.4 11.5 76.4 13.6 77.9 15.4 80.1 15.4 82.4 15.4 83.8 13.7 83.8 11.6zM89 6.7C89 5.9 89.6 5.3 90.4 5.3 91.2 5.3 91.8 5.9 91.8 6.7L91.8 7.3C92.6 6.2 93.7 5.2 95.6 5.2 98.3 5.2 99.9 7 99.9 9.8L99.9 16.3C99.9 17.1 99.3 17.7 98.5 17.7 97.7 17.7 97.1 17.1 97.1 16.3L97.1 10.7C97.1 8.8 96.2 7.7 94.5 7.7 92.9 7.7 91.8 8.8 91.8 10.7L91.8 16.3C91.8 17.1 91.2 17.7 90.4 17.7 89.6 17.7 89 17.1 89 16.3L89 6.7z"
            />
            <path
              fill="#73D50F"
              d="M104.7 1.6C104.7 1.1 105.1.7 105.6.7 106.1.7 106.5 1.1 106.5 1.6L106.5 7.8C107.3 6.5 108.5 5.5 110.6 5.5 113.5 5.5 115.2 7.4 115.2 10.3L115.2 16.9C115.2 17.4 114.8 17.8 114.3 17.8 113.8 17.8 113.4 17.4 113.4 16.9L113.4 10.7C113.4 8.5 112.2 7.1 110.1 7.1 108.1 7.1 106.5 8.6 106.5 10.8L106.5 16.8C106.5 17.3 106.1 17.7 105.6 17.7 105.1 17.7 104.7 17.3 104.7 16.8L104.7 1.6zM117.5 11.7C117.5 8.3 120.1 5.4 123.7 5.4 127.3 5.4 129.9 8.2 129.9 11.6 129.9 15 127.3 17.8 123.7 17.8 120.1 17.9 117.5 15.1 117.5 11.7zM128.1 11.7C128.1 9.1 126.2 7 123.7 7 121.1 7 119.4 9.1 119.4 11.6 119.4 14.2 121.3 16.2 123.8 16.2 126.3 16.3 128.1 14.2 128.1 11.7zM131.7 6.5C131.7 6 132.1 5.6 132.6 5.6 133.1 5.6 133.5 6 133.5 6.5L133.5 7.7C134.3 6.5 135.3 5.4 137.3 5.4 139.2 5.4 140.5 6.4 141.1 7.8 142 6.5 143.2 5.4 145.3 5.4 148 5.4 149.7 7.2 149.7 10.2L149.7 16.8C149.7 17.3 149.3 17.7 148.8 17.7 148.3 17.7 147.9 17.3 147.9 16.8L147.9 10.6C147.9 8.3 146.7 7 144.8 7 143 7 141.5 8.3 141.5 10.7L141.5 16.8C141.5 17.3 141.1 17.7 140.6 17.7 140.1 17.7 139.7 17.3 139.7 16.8L139.7 10.6C139.7 8.4 138.5 7.1 136.6 7.1 134.7 7.1 133.3 8.7 133.3 10.8L133.3 16.8C133.3 17.3 132.9 17.7 132.4 17.7 131.9 17.7 131.5 17.3 131.5 16.8L131.5 6.5 131.7 6.5zM158.2 17.9C154.9 17.9 152.3 15.4 152.3 11.7 152.3 8.3 154.7 5.5 158 5.5 161.5 5.5 163.5 8.4 163.5 11.5 163.5 12 163.1 12.3 162.7 12.3L154.1 12.3C154.4 14.9 156.2 16.3 158.3 16.3 159.8 16.3 160.9 15.7 161.7 14.9 161.8 14.8 162 14.7 162.2 14.7 162.6 14.7 163 15 163 15.5 163 15.7 162.9 15.9 162.7 16.1 161.6 17.2 160.2 17.9 158.2 17.9zM161.7 11C161.5 8.8 160.3 7 157.9 7 155.8 7 154.3 8.7 154 11L161.7 11zM164.8 16.3C164.6 16.2 164.5 16 164.5 15.7 164.5 15.3 164.8 14.9 165.3 14.9 165.5 14.9 165.6 14.9 165.7 15 166.9 15.8 168.2 16.3 169.5 16.3 170.9 16.3 172 15.6 172 14.4 172 13.2 170.6 12.7 169 12.3 167.1 11.8 165.1 11.1 165.1 8.9 165.1 6.9 166.8 5.5 169.1 5.5 170.4 5.5 171.7 5.9 172.9 6.5 173.1 6.6 173.3 6.9 173.3 7.2 173.3 7.6 173 8 172.5 8 172.3 8 172.2 8 172.1 7.9 171.1 7.3 170 7 169 7 167.6 7 166.7 7.7 166.7 8.7 166.7 9.8 168.2 10.3 169.8 10.7 171.6 11.3 173.6 12 173.6 14.1 173.6 16.4 171.7 17.7 169.4 17.7 167.8 17.8 166.1 17.3 164.8 16.3z"
            />
          </g>
        </g>
      </svg>
    </LogoH1>
  );
};
Logo.propTypes = {
  width: PropTypes.number,
};
Logo.defaultProps = {
  width: 390,
};

export const CenteredLogo = styled(Logo)`
  text-align: center;
`;
export default CenteredLogo;

export const StyledLogo = styled(CenteredLogo)`
  width: 355px;
  margin: 0 auto 20px auto;
  display: block;
`;

export const LayoutLogo = styled(Logo)`
  @media (max-width: 800px) {
    text-align: center;
  }
  @media (max-width: 1024px) {
    padding-left: 20px;
  }
  @media (max-width: 700px) {
    width: 100%;
    padding-left: 0;
    svg {
      width: 80%;
    }
  }
  @media (max-width: 34em) {
    margin: 0;
    width: 100%;

    svg {
      width: 55%;
      height: 70px;
    }
  }
`;
